import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PaymentAddonState {
  addon_product_id?: string;
  description?: string;
  discount?: number;
  image_name?: string;
  is_free?: boolean;
  is_free_shipping?: boolean;
  is_sold_out?: boolean;
  label?: string;
  per_month?: boolean;
  price?: number;
  regular_price?: number;
  sale_item_id?: string;
  shipping_address_required?: boolean;
  title?: string;
  type?: string;
  sales_tax_amount?: number;
  hasOffer: boolean;
}

const paymentAddonSlice = createSlice({
  name: "paymentAddon",
  initialState: { hasOffer: false } as PaymentAddonState,
  reducers: {
    setPaymentAddon(state, action: PayloadAction<PaymentAddonState>) {
      return { ...action.payload };
    },
    updatePaymentAddon(
      state,
      action: PayloadAction<Partial<Omit<PaymentAddonState, "hasOffer">>>
    ) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setPaymentAddon, updatePaymentAddon } =
  paymentAddonSlice.actions;

export default paymentAddonSlice;
